import { forwardRef } from "react";
import { styled } from "styled-components";

const Form = styled.form`
    display: flex;
    flex-direction: column;
`;

const Formulario = forwardRef(({ children, onSubmit }, ref) => {
    return (
        <Form ref={ref} onSubmit={onSubmit}>
            {children}
        </Form>
    );
});

Formulario.displayName = "Formulario";

export default Formulario;